import { ICompanyUser } from 'app/models/company-user'
import { ISingleCompanyUser } from 'app/models/single-company-user'
import ApiRequest from 'app/shared/data-access/api-request'
import { ICreateCompanyUserInput } from './create-company-user-input'
import { ISearchCompanyUsersOutput } from './search-company-users/search-company-users-output'
import { IUpdateCompanyUserInput } from './update-company-user-input'

export const CompanyUserRepository = {
  getCompanyUsers: (communityId: string, companyId: string) =>
    ApiRequest<null, ICompanyUser[]>({
      method: 'GET',
      path: `/communities/${communityId}/companies/${companyId}/companyusers`,
      responseType: 'json',
    }),
  createCompanyUser: async (communityId: string, companyId: string, input: ICreateCompanyUserInput) =>
    ApiRequest<ICreateCompanyUserInput, null>({
      method: 'PUT',
      path: `/communities/${communityId}/companies/${companyId}/companyusers`,
      responseType: 'json',
      data: input,
    }),
  updateCompanyUser: async (
    communityId: string,
    companyId: string,
    companyUserId: string,
    input: IUpdateCompanyUserInput
  ) =>
    ApiRequest<IUpdateCompanyUserInput, null>({
      method: 'POST',
      path: `/communities/${communityId}/companies/${companyId}/companyusers/${companyUserId}`,
      responseType: 'json',
      data: input,
    }),
  deleteCompanyUser: async (communityId: string, companyId: string, companyUserId: string) =>
    ApiRequest<null, null>({
      method: 'DELETE',
      path: `/communities/${communityId}/companies/${companyId}/companyusers/${companyUserId}`,
      responseType: 'json',
    }),
  getCompanyUser: (communityId: string, companyId: string, companyUserId: string) =>
    ApiRequest<null, ISingleCompanyUser>({
      method: 'GET',
      path: `/communities/${communityId}/companies/${companyId}/companyusers/${companyUserId}`,
      responseType: 'json',
    }),
  searchCompanyUsers: async (filters?: {
    email?: string
  }
  ) => await ApiRequest<null, ISearchCompanyUsersOutput[]>({
    method: 'GET',
    path: '/companyusers',
    responseType: 'json',
    params: filters
  })
}
